<script>
	import { onMount, onDestroy } from 'svelte'
	import { getContext } from 'svelte'
	import { styles } from '../../../library/scripts/styles.js'
	import { v4 as uuidv4 } from 'uuid'
	import { urlAdmin } from '../../../library/scripts/Setup.svelte'
	import {
		adminUpdateDrinksEntry,
		check_values,
		SingleItem,
		adminDrinksCategory,
		sort_array,
		remove_duplicates,
		check_category,
		update_categories,
	} from '../AdminModule.svelte'
	import Shader from '../../../library/ShadersAndSpinners/Shader.svelte'
	import Alert from '../../../modals/Alert.svelte'

	const globals = getContext('globals')

	const shadow = globals.boxShadow
	const fsL = globals.fsL
	const fsN = globals.fsN
	const fsS = globals.fsS
	const color = globals.colorMain
	const inputFocus = globals.bgLight
	const buttonColor = globals.buttonColor
	const buttonHover = globals.buttonHover

	//array that holds all categories & menu order
	let categories = []

	//variable to show or hide category input according to selected radio button
	let hideCategInput = true

	// hide inputs for category upodate
	let hideItemInput = false

	const stoCategoryArray = adminDrinksCategory.subscribe((value) => {
		categories = value
		if (categories.length > 0) {
			categories = remove_duplicates(categories)
			categories = sort_array(categories)
		} else {
			categories.length = 0
			hideCategInput = true
		}
	})

	//if the session storage is empty we have no entries yet
	//hide radio-buttons and category select field
	let menuExist

	//the new element to add
	let addElement = {}

	//values for item entries
	let itemCategory = ''
	let itemId = ''
	let itemName = ''
	let itemQuantity = '-'
	let itemPrice = ''
	let itemCurrency = 'CHF'
	let itemOrder = 0

	//store the menu
	let menu = []

	//check for doubled items
	let double = false

	//success and error message
	let error = false
	let success = false

	//message to the user
	let message = ''

	// for the category merge
	let message2 = ''
	let alertMerge = false

	//alert window
	let alertError = false

	// radio buttons
	let catAction = 'existing'

	//create single item entries if item is changed by user
	let singleItem = false
	const stoSingleItem = SingleItem.subscribe((value) => {
		singleItem = value
	})

	$: if (singleItem) {
		singleItem = singleItem.split('~')
		itemCategory = singleItem[0]
		itemId = singleItem[1]
		itemName = singleItem[2]
		itemQuantity = singleItem[3]
		itemPrice = parseFloat(singleItem[4]).toFixed(2)
		itemCurrency = singleItem[5]
		itemOrder = singleItem[6]
		catAction = 'existing'
		SingleItem.set(false)
	}

	// clear from
	const clear_form = () => {
		itemCategory = ''
		itemId = ''
		itemName = ''
		itemQuantity = '-'
		itemPrice = ''
	}

	function check_update() {
		if (itemCategory === '') {
			error = true
			message = 'select category'
			set_error()
		}

		if (itemName === '') {
			error = true
			message = 'enter name'
			set_error()
		}

		if (itemName === itemCategory) {
			error = true
			message = 'same category'
			set_error()
		}

		// cannot have existing category name
		categories.forEach((c) => {
			if (c[0] !== itemCategory && c[0] === itemName) {
				error = true
				alertMerge = true
				message = `Do you realy want to merge ${itemCategory} with ${itemName}?`
				message2 = '!!THIS CANNOT BE UNDONE!!'
			}
		})
		if (error) return
		const updated = update_categories('drinks', itemCategory, itemName)
		if (updated) {
			catAction = 'existing'
			clear_form()
		}
	}

	function merge_categories() {
		error = false
		alertMerge = false
		const updated = update_categories('drinks', itemCategory, itemName)
		if (updated) {
			catAction = 'existing'
			clear_form()
		}
	}

	//create the entry and check for errors
	function check_item() {
		//the default currency is CHF. We have to add it manually
		if (itemCurrency === '') itemCurrency = 'CHF'

		// if its a new item item-order is equal to category-length
		//create the element to add
		addElement = {
			category: itemCategory,
			id: itemId,
			name: itemName,
			quantity: itemQuantity,
			price: parseFloat(itemPrice).toFixed(2),
			currency: itemCurrency,
			menuorder: itemOrder,
		}
		if (hideCategInput) itemOrder = categories.length

		//if all is well we add the item to the storage
		const check = check_values('drinks', addElement)

		if (check === true) {
			add_item(addElement)
			return
		}

		error = true
		message = check

		set_error()
	}

	const set_error = () => {
		const toError = setTimeout(() => {
			error = false
			message = ''
			clearTimeout(toError)
		}, 2000)
	}

	//add element and handle views of the DOM
	const add_item = (item) => {
		// check if the category exists
		const chckCategory = check_category(item.category, categories)

		// if its an existing category we have to set the itemOrder to the categories order
		if (chckCategory) {
			if (categories.length > 0) {
				categories.forEach((e) => {
					if (e[0] === itemCategory) {
						itemOrder = parseInt(e[1])
					}
				})
			}
		}

		//hide inputfield for category
		hideCategInput = false

		//add the newly created category to categories if it does not exist
		if (categories.length > 0) {
			categories = [...categories, [item.category, item.menuorder]]
			categories = remove_duplicates(categories)

			// sort array
			categories = sort_array(categories)
		}
		if (!categories.length) {
			categories = [[item.category, item.menuorder]]
		}

		// update store
		adminDrinksCategory.set(categories)

		//create the unique id for the element
		const uniqueId = uuidv4()
		if (itemId === '') item.id = uniqueId
		else item.id = itemId

		const safeEntry = save_entry(item)

		//add a message if the record is entered successfully
		if (safeEntry) {
			success = true
			message = 'item saved'
			const toSuccess = setTimeout(() => {
				reset_error()
				clearTimeout(toSuccess)
			}, 2000)
		}

		//reset variables
		itemCategory = ''
		itemId = ''
		itemName = ''
		itemQuantity = '-'
		itemPrice = ''
	}

	//safe the entry to the session store
	const save_entry = (item) => {
		//variable to check for doubled entries
		let checkDouble = false

		//the menu does not yet exist, we create it
		if (!menuExist) {
			menu = [item]
			const addedToDb = save_item_to_db(item)
			if (addedToDb) {
				sessionStorage.setItem('drinks', JSON.stringify(menu))
				adminUpdateDrinksEntry.set(JSON.stringify(menu))
				menuExist = true
				return true
			}
		} else {
			const menuObjects = JSON.parse(sessionStorage.getItem('drinks'))
			//clean old menu
			menu.length = 0
			//add objects to menu
			menuObjects.forEach((item) => {
				menu = [...menu, item]
			})

			/*
			 * check if we have a doubled entry (quantity does not count)
			 * the price has only double equals because we changed the type from a string to a number!!
			 * remember === checks for value AND type
			 */
			if (!document.getElementById('singleItem')) {
				menu.forEach((entry) => {
					if (entry.category === item.category && entry.name === item.name && entry.price == item.price) {
						double = true
						error = true
						message = 'item already exists'
						checkDouble = true
						set_error()
						return false
					}
				})
			}

			// if it's an update of existing product
			if (document.getElementById('singleItem')) {
				menu.forEach((entry) => {
					if (entry.id === itemId) {
						entry.category = itemCategory
						entry.name = itemName
						entry.quantity = itemQuantity
						entry.price = parseFloat(itemPrice).toFixed(2)
						entry.currency = itemCurrency
					}
				})
			}

			//ther is no duplicate, we add the entry
			if (!checkDouble) {
				//add item to the DB
				const addedToDb = save_item_to_db(item)

				//only add the item to the session storage if it's saved to DB first
				if (addedToDb) {
					if (!document.getElementById('singleItem')) menu = [...menu, item]
					sessionStorage.setItem('drinks', JSON.stringify(menu))

					//update the preview
					adminUpdateDrinksEntry.set(JSON.stringify(menu))
					return true
				}
			}

			return false
		}
	}

	// ******************************** HELPER FUNCTIONS ***********************************//

	//safe entry to db
	const save_item_to_db = async (item) => {
		const saveItem = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'save_menu_entry',
				dbtable: 'drinks',
				data: {
					category: item.category,
					id: item.id,
					name: item.name,
					quantity: item.quantity,
					price: item.price,
					currency: item.currency,
					menuorder: itemOrder,
				},
			}),
		})

		const dataResponse = await saveItem.json()
		if (dataResponse) {
			// update categories

			categories.push([item.category, item.menuorder])
			categories = remove_duplicates(categories)
			categories = sort_array(categories)

			adminDrinksCategory.set(categories)
			itemOrder = categories.length
			catAction = 'existing'
		}

		return categories
	}

	//reset error messages
	const reset_error = () => {
		error = false
		success = false
		alertError = false
	}

	// reset merge
	const reset_merge = () => {
		alertMerge = false
		message = ''
		message2 = ''
	}

	$: switch (catAction) {
		case 'existing':
			hideCategInput = false
			hideItemInput = false
			break

		case 'new':
			hideCategInput = true
			hideItemInput = false
			break

		case 'update':
			hideCategInput = false
			hideItemInput = true

			break
	}

	onMount(async () => {
		const getCategory = await fetch(urlAdmin, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				cmd: 'get_menu_categories',
				dbtable: 'drinks',
			}),
		})

		const dataResponse = await getCategory.json()

		// categories arrays with category and menu order
		categories = dataResponse.categories

		// sort array
		categories = remove_duplicates(categories)
		categories = sort_array(categories)

		itemOrder = categories.length

		if (dataResponse.categories.length > 0) {
			hideCategInput = false
			menuExist = true
		}
	})

	onDestroy(() => {
		stoSingleItem
		stoCategoryArray
	})
</script>

<div class="container">
	<div class="title" use:styles={{ color, fsL }}>CREATE ITEM</div>
	<div class="radio_container">
		<div class="radio">
			<input use:styles={{ fsN, color, shadow }} type="radio" bind:group={catAction} value="existing" />

			<label use:styles={{ fsN, color }} for="sg">existing category</label>
		</div>

		<div class="radio">
			<input use:styles={{ fsN, color, shadow }} type="radio" bind:group={catAction} value="new" />

			<label use:styles={{ fsN, color }} for="ng">new category</label>
		</div>

		<div class="radio">
			<input use:styles={{ fsN, color, shadow }} type="radio" bind:group={catAction} value="update" />

			<label use:styles={{ fsN, color }} for="ng">rename category</label>
		</div>
	</div>
	<form use:styles={{ fsS }}>
		{#if menuExist != null}
			{#if !hideCategInput}
				<label use:styles={{ fsN, color }} for="selectGroup">category</label>
				<select use:styles={{ shadow, fsN, color }} id="selectGroup" bind:value={itemCategory}>
					<option value="" selected>--</option>
					{#if categories.length > 0}
						{#each categories as category}
							<option value={category[0]}>{category[0]}</option>
						{/each}
					{/if}
				</select>
			{/if}
		{/if}

		{#if !menuExist || hideCategInput}
			<label use:styles={{ fsN, color }} for="category">category</label>
			<input
				use:styles={{ fsN, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="category"
				maxlength="50"
				bind:value={itemCategory}
			/>
		{/if}

		<label use:styles={{ fsN, color }} for="item">name</label>
		<input
			use:styles={{ fsN, color, shadow, inputFocus }}
			input
			on:focus={reset_error}
			type="text"
			id="item"
			maxlength="50"
			bind:value={itemName}
		/>

		{#if !hideItemInput}
			<label use:styles={{ fsN, color }} for="size">quantity</label>
			<input
				use:styles={{ fsN, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="size"
				maxlength="6"
				bind:value={itemQuantity}
			/>
			<label use:styles={{ fsN, color }} for="price">price</label>
			<input
				use:styles={{ fsN, color, shadow, inputFocus }}
				on:focus={reset_error}
				type="text"
				id="price"
				maxlength="6"
				bind:value={itemPrice}
			/>
			<label use:styles={{ fsN, color }} for="currency">currency</label>
			<select use:styles={{ shadow, fsN, color }} id="currency" bind:value={itemCurrency}>
				<option value="CHF" selected>CHF</option>
				<option value="EUR">EUR</option>
				<option value="USD">USD</option>
				<option value="ZAR">ZAR </option>
				<option value="YEN">YEN</option>
			</select>
		{/if}

		<!-- error and other messages -->
		{#if error}
			<div class="message error">{message}</div>
		{/if}
		{#if success}
			<div class="message success">{message}</div>
		{/if}
	</form>
	<div class="button_container">
		<button use:styles={{ fsS, shadow, buttonColor, buttonHover }} on:click|preventDefault={clear_form}>clear</button>
		{#if hideItemInput}
			<button use:styles={{ fsS, shadow, buttonColor, buttonHover }} on:click|preventDefault={check_update}>save</button
			>
		{:else}
			<button use:styles={{ fsS, shadow, buttonColor, buttonHover }} on:click|preventDefault={check_item}>save</button>
		{/if}
	</div>
</div>

{#if alertError}
	<Shader>
		<div slot="content">
			<Alert {message} showOkButton={false} alertMessage="ERROR" on:alertclose={reset_error} />
		</div>
	</Shader>
{/if}

{#if alertMerge}
	<Shader>
		<div slot="content">
			<Alert
				{message}
				{message2}
				alertMessage="DANGER ZONE"
				on:alertok={merge_categories}
				on:alertclose={reset_merge}
			/>
		</div>
	</Shader>
{/if}

<style>
	.container {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		width: 100%;
		cursor: default;
		user-select: none;
	}

	.button_container {
		display: flex;
		justify-content: flex-end;
		width: 100%;
		margin-top: 20px;
	}

	.title {
		font-size: var(--fsL);
		font-weight: bold;
		color: var(--color);
		margin: 30px 0 20px 20px;
	}

	form {
		display: grid;
		grid-template-columns: 30% 70%;
		width: 85%;
		margin-left: 3%;
		font-size: var(--fsS);
	}

	label {
		display: flex;
		align-items: flex-start;
		font-size: var(--fsN);
		color: var(--color);
	}

	input[type='radio'] {
		margin: 0;
		padding: 0;
		outline: none;
		width: clamp(12px, 1.27vw, 20px);
		height: clamp(12px, 1.59vw, 20px);
	}

	input[type='text'] {
		outline: none;
		box-shadow: 3px 3px 3px var(--shadow);
		font-size: var(--fsN);
		border: 1px solid ghostwhite;
		background-color: transparent;
		color: var(--color);
		width: 100%;
	}

	input[type='text']:focus {
		background-color: var(--inputFocus);
	}

	select {
		border: 1px solid ghostwhite;
		background-color: transparent;
		box-shadow: 3px 3px 3px var(--shadow);
		color: var(--color);
	}

	option {
		background-color: black;
		color: white;
	}

	button {
		width: 20%;
		grid-column-start: 1;
		grid-column-end: 3;
		justify-self: flex-end;
		margin-right: 20px;
		border-radius: 5px;
		font-size: var(--fsS);
		color: var(--buttonColor);
		box-shadow: 3px 3px 3px var(--shadow);
		background-color: transparent;
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonHover);
	}

	.radio_container {
		display: grid;
		grid-template-columns: 33% 33% 1fr;
		width: 97%;
		margin-left: 3%;
	}

	.radio {
		display: grid;
		grid-template-columns: 20% 80%;
		align-items: start;
		margin-bottom: 10%;
	}

	.message {
		grid-column-start: 1;
		grid-column-end: 3;
		justify-self: center;
		font-size: clamp(0.8rem, 1.1vw, 1.2rem);
	}

	.success {
		color: green;
	}

	.error {
		color: red;
	}
</style>
